import { render, staticRenderFns } from "./materReturn.vue?vue&type=template&id=79b012d4&"
import script from "./materReturn.vue?vue&type=script&lang=js&"
export * from "./materReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports